import { render, staticRenderFns } from "./CourseMaterial.vue?vue&type=template&id=e37975c2"
import script from "./CourseMaterial.vue?vue&type=script&lang=js"
export * from "./CourseMaterial.vue?vue&type=script&lang=js"
import style0 from "./CourseMaterial.vue?vue&type=style&index=0&id=e37975c2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/tony.yu/Documents/asd-tmm-client-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../../../Users/tony.yu/Documents/asd-tmm-client-vue/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDataTable,VIcon})
